import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import { Autocomplete } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleSubmitNewPatriotAlert } from "./EditCameraUtils/handleSubmitNewPatriotAlert";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { PatriotDeliverySummary } from "../../common/PatriotDrawIgnoreZonesGate";
import { PatriotDeliveryChoice } from "../../common/PatriotDeliveryChoice";

export const AddPatriotAlertDialog = ({
  setAddPatriotAlertDialogOpen,
  addPatriotAlertDialogOpen,
  patriotAlerts,
  setBackdropLoadingScreenOn,
  setCameraGeneralInfo,
  setCameraGeneralInfoBackup,
  setGeneralInfoChangesMade,
  setPatchObject,
  setPatriotAlerts,
  setActiveTab,
  cameraGeneralInfoBackup,
  setIgnoreZonesBreadCrumbs,
  handleSitesBreadcrumbClick,
  handleSingularSiteBreadcrumbClick,
  cameraGeneralInfo,
  immixAlerts,
  setAddImmixAlertDialogOpen,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  setDeleteImmixAlertDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  immixAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
}: {
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>;
  addPatriotAlertDialogOpen: boolean;
  patriotAlerts: any;
  setBackdropLoadingScreenOn: any;
  setCameraGeneralInfo: any;
  setCameraGeneralInfoBackup: any;
  setGeneralInfoChangesMade: any;
  setPatchObject: any;
  setPatriotAlerts: any;
  setActiveTab: any;
  cameraGeneralInfoBackup: any;
  setIgnoreZonesBreadCrumbs: any;
  handleSitesBreadcrumbClick: any;
  handleSingularSiteBreadcrumbClick: any;
  cameraGeneralInfo: any;
  immixAlerts: any;
  setAddImmixAlertDialogOpen: any;
  setSendingImmixTest: any;
  setImmixTestSuccessDialogOpen: any;
  setImmixTestFailDialogOpen: any;
  setDeleteImmixAlertDialogOpen: any;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: any;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: any;
  immixAlertsOnCamera: any;
  sureViewAlertsOnCamera: any;
  siteInfo: any;
  webhooksAlertsOnCamera: any;
  sentinelAlertsOnCamera: any;
  boldAlertsOnCamera: any;
  patriotAlertsOnCamera: any;
  softguardAlertsOnCamera: any;
  evalinkAlertsOnCamera: boolean;
}) => {
  const { cameraStreams, cameraStreamsPatchObject } = useEditCameraStore();

  const streamNames = new Map();
  cameraStreams?.forEach((object: any, index: number) => {
    streamNames.set(`${object.name} (${object.product})`, index);
  });

  const navigate = useNavigate();

  const [postObject, setPostObject] = React.useState({
    id: -1,
    patriot_server: "",
    patriot_client_no: "",
    patriot_username: "",
    patriot_password: "",
    patriot_zone_number: "",
    patriot_type_number: "",
    patriot_send_video: false,
    draw_ignore_zones: false,
  });

  const [selectedStreamNames, setSelectedStreamNames] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    if (patriotAlerts[0]) {
      setPostObject({
        id: -1,
        patriot_server: patriotAlerts[0].patriot_server,
        patriot_client_no: patriotAlerts[0].patriot_client_no,
        patriot_username: patriotAlerts[0].patriot_username,
        patriot_password: patriotAlerts[0].patriot_password,
        patriot_zone_number: patriotAlerts[0].patriot_zone_number,
        patriot_type_number: patriotAlerts[0].patriot_type_number,
        patriot_send_video: patriotAlerts[0].patriot_send_video,
        draw_ignore_zones: patriotAlerts[0].draw_ignore_zones,
      });
    }
  }, []);

  return (
    <Dialog open={addPatriotAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">Add Patriot Alert</DialogTitle>
      <DialogContent>
        {cameraStreams && cameraStreams.length > 1 && (
          <div>
            <FormLabel component="legend" sx={{ paddingBottom: 1 }}>
              {" "}
              Streams*
            </FormLabel>
            <Autocomplete
              multiple
              options={cameraStreams.map((object: any) => {
                return `${object.name} (${object.product})`;
              })}
              sx={{ width: 400 }}
              renderInput={(params) => <TextField {...params} />}
              onChange={(event, value) => {
                setSelectedStreamNames(value);
              }}
            />
            <br></br>
          </div>
        )}
        <TextField
          id="patriot_server"
          variant="standard"
          label="Patriot Server"
          defaultValue={patriotAlerts[0] ? patriotAlerts[0].patriot_server : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, patriot_server: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="patriot_client_no"
          variant="standard"
          label="Patriot client no"
          defaultValue={
            patriotAlerts[0] ? patriotAlerts[0].patriot_client_no : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return {
                ...previousState,
                patriot_client_no: event.target.value,
              };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="patriot_username"
          variant="standard"
          label="Patriot username"
          defaultValue={
            patriotAlerts[0] ? patriotAlerts[0].patriot_username : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, patriot_username: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="patriot_password"
          variant="standard"
          label="Patriot password"
          defaultValue={
            patriotAlerts[0] ? patriotAlerts[0].patriot_password : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, patriot_password: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="patriot_zone_number"
          variant="standard"
          label="Patriot zone number"
          defaultValue={
            patriotAlerts[0] ? patriotAlerts[0].patriot_zone_number : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return {
                ...previousState,
                patriot_zone_number: event.target.value,
              };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="patriot_type_number"
          variant="standard"
          label="Patriot type number"
          defaultValue={
            patriotAlerts[0] ? patriotAlerts[0].patriot_type_number : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return {
                ...previousState,
                patriot_type_number: event.target.value,
              };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <PatriotDeliveryChoice
          name="add-patriot-alert-delivery"
          sendVideo={postObject.patriot_send_video}
          drawIgnoreZones={postObject.draw_ignore_zones}
          onChange={(values) => {
            setPostObject((previousState: any) => ({
              ...previousState,
              ...values,
            }));
          }}
        />
        <br></br>
        <PatriotDeliverySummary
          sendVideo={postObject.patriot_send_video}
          drawIgnoreZones={postObject.draw_ignore_zones}
        />
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddPatriotAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            const selectedStreamIndexs: number[] = [];

            const streamsObjectToPost = JSON.parse(
              JSON.stringify(cameraStreamsPatchObject)
            );

            if (cameraStreams && cameraStreams.length > 1) {
              selectedStreamNames.forEach((streamName: string) => {
                selectedStreamIndexs.push(streamNames.get(streamName));
              });

              selectedStreamIndexs.forEach((streamIndex: number) => {
                if (streamsObjectToPost[streamIndex]) {
                  streamsObjectToPost[streamIndex].patriot_alerts = [
                    ...streamsObjectToPost[streamIndex].patriot_alerts,
                    postObject,
                  ];
                }
              });
            }

            if (cameraStreams && cameraStreams.length === 1) {
              streamsObjectToPost[0].patriot_alerts.push(postObject);
            }

            setAddPatriotAlertDialogOpen(false);
            setBackdropLoadingScreenOn(true);
            handleSubmitNewPatriotAlert(
              cameraGeneralInfo,
              patriotAlerts,
              streamsObjectToPost,
              navigate,
              setBackdropLoadingScreenOn,
              setCameraGeneralInfo,
              setCameraGeneralInfoBackup,
              setGeneralInfoChangesMade,
              setPatchObject,
              setPatriotAlerts,
              setActiveTab,
              setAddPatriotAlertDialogOpen,
              cameraGeneralInfoBackup,
              setIgnoreZonesBreadCrumbs,
              handleSitesBreadcrumbClick,
              handleSingularSiteBreadcrumbClick,
              immixAlerts,
              setAddImmixAlertDialogOpen,
              setSendingImmixTest,
              setImmixTestSuccessDialogOpen,
              setImmixTestFailDialogOpen,
              setDeleteImmixAlertDialogOpen,
              sureviewAlerts,
              setAddSureviewAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              immixAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera
            );
          }}
          text="Submit"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
